import _map from 'lodash/map';
import React, { Component } from "react";
import ReactSVG from "react-svg";
import { wobblyLineProps } from "src/pages/slide";
import { inViewService } from 'src/services/InViewService';
import { BlobFiller } from '../../../components/blob-filler/BlobFiller';
import { HowSteps } from '../how-steps/HowSteps';
import "./HowSlideBase.scss";

export class HowSlideBase extends Component {
  blob = null;
  app = null;

  constructor(props) {
    super(props);
    this.state = {
      isInView: true,
    }
  }

  setupViewOnScroll({ id }) {
    this.scrollId = 'how-slide-' + id;
    inViewService.add({ id: this.scrollId, element: this.refs.image, onScroll: isInView => this.setState({ isInView }) });
  }

  componentWillUnmount() {
    inViewService.remove(this.scrollId);
  }

  createBlobFills({ fills, dimensions }) {
    const color = 0xf0325a;
    const { x, y, width, height } = dimensions;

    const blobs = _map(fills, (fill, i) => {
      const { x, y, anchors } = fill;
      return {
        x, y, anchors, color,
      };
    });

    return (
      <BlobFiller fills={blobs}
        isInView={true}
        x={x} y={y}
        width={width} height={height}
      />
    );
  }

  createSlide({ step, title, image, content, fills, fillDimensions }) {
    const blobFills = this.createBlobFills({
      fills,
      dimensions: fillDimensions
    });

    return (
      <div className="HowSlide" {...wobblyLineProps(this.props)}>
        <div className="Page-slide">
          <div className="Page-content">
            <HowSteps step={step} title={title} />
            {content}
          </div>
          <div className="Page-image" ref="image">
            {blobFills}
            <ReactSVG src={image} className="HowSlide-image" />
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (<div />);
  }
}
